import type { PlaceResult } from "@/lib/api/misc";

export function isPlaceResult(value: unknown): value is PlaceResult {
  if (!value || typeof value !== "object") return false;
  const place = value as Partial<PlaceResult>;
  return (
    typeof place.display === "string" &&
    place.display.trim().length > 0 &&
    typeof place.name === "string" &&
    place.name.trim().length > 0 &&
    typeof place.latitude === "number" &&
    typeof place.longitude === "number" &&
    typeof place.timezone === "string"
  );
}
